import { smallBold, thinBold, typoThin } from "./typography";

// First create a styles object for reuse
export const windowsTableStyles = () => ({
  container: {
    boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
    borderRadius: "0px",
    border: "1px solid #e0e0e0",
    backgroundColor: "#ffffff",
  },
  headerCell: {
    ...thinBold,
    fontFamily: "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
    fontSize: "10.5px",
    color: "#252525",
    padding: "4px 8px",
    borderBottom: "1px solid #e0e0e0",
    // height: "20px",  // Ensure the header cell has the same height
    // minHeight: "20px",
  },
  cell: {
    ...typoThin,
    fontFamily: "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
    fontSize: "10.5px",
    paddingY: "2px",
    paddingX: "8px",
    borderBottom: "1px solid #e0e0e0",
    fontWeight: "400",
    color: "rgb(53,53,53)"
  },
  typography: {
    fontFamily: "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
    fontSize: "10.5px",
    fontWeight: 600,
    color: "#252525",
    marginBottom: "12px",
  },
  row: {
    height: "30px",  // Set a fixed row height
    minHeight: "30px",
    "&:hover": {
      backgroundColor: "#e3f2fd",
      transition: "background-color 0.1s ease",
    },
  },
});

